import { Lock } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { cn } from '@/libs/utils'

interface ReadOnlyHintProps {
  /** Entity label used in the message, e.g. "Customer", "Vehicle". */
  entity: string
  className?: string
}

/**
 * Info banner shown on details pages while in read-only mode, prompting the
 * user to open the Actions menu and click "Edit {entity}" to unlock fields.
 */
export function ReadOnlyHint({ entity, className }: ReadOnlyHintProps) {
  const { t } = useTranslation()
  return (
    <div className={cn('hint-banner', className)} role="note">
      <Lock className="w-4 h-4" />
      {t('common.readOnlyHint', { entity })}
    </div>
  )
}

export default ReadOnlyHint
